// src/components/ui/shop/PurchaseConfirmationModal.js
// eslint-disable-next-line no-unused-vars
import React from 'react';
import styled from 'styled-components';
import {useTranslation} from 'react-i18next';

const PurchaseConfirmationModal = ({item, price, currencyMode, onCancel, onConfirm}) => {
  const {t} = useTranslation();

  return (
    <Overlay>
      <Modal>
        <Header>
          <Title>{t('purchaseConfirmation.title')}</Title>
        </Header>
        <Content>
          <Message>{t('purchaseConfirmation.messagePrompt')}</Message>
          <Message>
            <strong>
              {item.item_count} x {item.item_name}
            </strong>
          </Message>
          <Message>
            <strong>
              {price}{' '}
              {currencyMode === 'arcanium'
                ? t('purchaseConfirmation.currency.arc')
                : t('purchaseConfirmation.currency.vp')}
            </strong>
          </Message>
        </Content>
        <Footer>
          <Button onClick={onCancel}>{t('purchaseConfirmation.cancel')}</Button>
          <Button primary onClick={onConfirm}>
            {t('purchaseConfirmation.confirm')}
          </Button>
        </Footer>
      </Modal>
    </Overlay>
  );
};

export default PurchaseConfirmationModal;

const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
`;

const Modal = styled.div`
  background-image: url(/assets/ui/container-bg.png);
  background-repeat: no-repeat;
  background-position: center center;
  background-size: 100% 100%;
  border-radius: 8px;
  width: 400px;
  max-width: 90%;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.3);
  overflow: hidden;
`;

const Header = styled.div`
  padding: 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const Title = styled.h3`
  margin: 0;
  margin-left: 20px;
  margin-top: 10px;
`;

const Content = styled.div`
  padding: 16px;
  text-align: center;
`;

const Message = styled.p`
  margin: 8px 0;
  font-size: 1rem;
`;

const Footer = styled.div`
  padding: 16px;
  display: flex;
  justify-content: center;
  gap: 8px;
  margin-bottom: 10px;
`;

const Button = styled.button`
  padding: 8px 16px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  color: #fff;
  &:hover {
    opacity: 0.9;
  }
`;
